import ReactDOM from 'react-dom';

import routes from './routes';

import 'bootstrap/dist/css/bootstrap.css';
import 'sanitize.css';
import './stylesheets/index.css';

ReactDOM.render(routes, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js